"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'refresh',
    name: 'Refresh',
    background_color: '#fef2c9',
    background_image: 'https://assets.raydiant.com/images/refresh.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/refresh-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/PermanentMarker-Regular.woff',
    heading_text_color: '#ff9300',
    heading_2_font: 'https://fonts.raydiant.com/PermanentMarker-Regular.woff',
    heading_2_text_color: '#ff571b',
    body_font: 'https://fonts.raydiant.com/Poppins-Regular.woff',
    body_text_color: '#333333',
    border_color: '#051727',
};
//# sourceMappingURL=refresh.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/refresh.js